export const servicePhoneNumber = "+420554818555";
